import { INavData } from '@coreui/angular';

export const navItems: INavData[] = [
  {
    name: 'Dashboard',
    url: '/dashboard',
    // iconComponent: { name: 'cil-speedometer' },
  },
  {
    name: "User's Manage",
    url: '/user',
    // iconComponent: { name: 'cil-user' },
    children: [
      {
        name: 'User List',
        url: '/user/list'
      },
      {
        name: 'User Kyc',
        url: '/user/kyc'
      },
      {
        name: 'Wallet Summary',
        url: '/walletsummary'
      },
      {
        name: 'User Summary',
        url: '/usersummary'
      },
    ]
  },
  {
    name: "Manual KYC",
    url: '/kyc',
    // iconComponent: { name: 'cil-user' },
    children: [
      {
        name: 'Valid Documents',
        url: '/kyc/valid-docs'
      }
    ]
  },
  // {
  //   name: 'Valid KYC KYCS',
  //   url: '/manual-kyc',
  //   // iconComponent: { name: 'cil-list' }
  // },
  {
    name: "Spot Trade",
    url: '/spottrade',
    // iconComponent: { name: 'cil-user' },
    children: [
      {
        name: 'Pairs',
        url: '/spottrade/pairlist'
      },

      {
        name: 'Order History',
        url: '/spottrade/orderhistory'
      },

      {
        name: 'Trade History',
        url: '/spottrade/tradehistory'
      },

    ]
  },
  {
    name: "Bot Subscription",
    url: '/subscription',
    // iconComponent: { name: 'cil-user' },
    children: [
      {
        name: 'Subscription',
        url: '/subscription/list'
      },
      {
        name: 'Plans',
        url: '/subscription/planlist'
      },
      {
        name: 'Purchased Details',
        url: '/subscription/purchase'
      },
    ]
  },
  {
    name: "DCA BOT",
    url: '/botdetails',
    children: [
      // {
      //   name: 'Trade History',
      //   url: '/botdetails/tradehistory'
      // },
      {
        name: 'Bot History',
        url: '/botdetails/bothistory'
      },

      {
        name: 'Open Orders',
        url: '/botdetails/limitorders'
      },

      {
        name: 'Bot Trade History ',
        url: '/botdetails/botordersall'
      },
      {
        name: 'All Bot History',
        url: '/botdetails/allbothistory'
      },

    ]
  },
  {
    name: "Grid BOT",
    url: '/grid-bot',
    children: [
      {
        name: 'Bot History',
        url: '/grid-bot/grid-bot-history'
      },
      {
        name: 'Bot Position History ',
        url: '/grid-bot/grid-bot-position'
      },
      {
        name: 'Bot Orders',
        url: '/grid-bot/grid-bot-orders'
      },
      {
        name: 'Bot Passbook',
        url: '/grid-bot/grid-bot-passbook'
      },
    ]
  },
  // {
  //   name: "CRED Up Side BOT",
  //   url: '/admin-trade-bot',
  //   children: [
  //     {
  //       name: 'Bot History',
  //       url: '/admin-trade-bot/vmap-bot/vmap-bot-history'
  //     },
  //     {
  //       name: 'Bot Position History ',
  //       url: '/admin-trade-bot/vmap-bot/vmap-bot-position'
  //     },
  //     {
  //       name: 'Bot Orders',
  //       url: '/admin-trade-bot/vmap-bot/vmap-bot-orders'
  //     },
  //     {
  //       name: 'Report',
  //       url: '/admin-trade-bot/vmap-bot/vmap-user-report'
  //     },
  //   ]
  // },
  {
    name: "Hanuman BOT",
    url: '/admin-trade-bot-down-side',
    children: [
      {
        name: 'Bot History',
        url: '/admin-trade-bot-down-side/vmap-bot/vmap-bot-history'
      },
      {
        name: 'Bot Position History ',
        url: '/admin-trade-bot-down-side/vmap-bot/vmap-bot-position'
      },
      {
        name: 'Bot Orders',
        url: '/admin-trade-bot-down-side/vmap-bot/vmap-bot-orders'
      },
      {
        name: 'Report',
        url: '/admin-trade-bot-down-side/vmap-bot/vmap-user-report'
      },
    ]
  },
  // {
  //   name: "Hanuman Up Side BOT",
  //   url: '/hanuman-trade-bot-up-side',
  //   children: [
  //     {
  //       name: 'Bot History',
  //       url: '/hanuman-trade-bot-up-side/vmap-bot/vmap-bot-history'
  //     },
  //     {
  //       name: 'Bot Position History ',
  //       url: '/hanuman-trade-bot-up-side/vmap-bot/vmap-bot-position'
  //     },
  //     {
  //       name: 'Bot Orders',
  //       url: '/hanuman-trade-bot-up-side/vmap-bot/vmap-bot-orders'
  //     },
  //     {
  //       name: 'Report',
  //       url: '/hanuman-trade-bot-up-side/vmap-bot/vmap-user-report'
  //     },
  //   ]
  // },
  {
    name: "Guru BOT",
    url: '/guru-bot',
    children: [
      {
        name: 'Bot History',
        url: '/guru-bot/vmap-bot/vmap-bot-history'
      },
      {
        name: 'Bot Position History ',
        url: '/guru-bot/vmap-bot/vmap-bot-position'
      },
      {
        name: 'Bot Orders',
        url: '/guru-bot/vmap-bot/vmap-bot-orders'
      },
      {
        name: 'Report',
        url: '/guru-bot/vmap-bot/vmap-user-report'
      },
    ]
  },
  {
    name: "Arbitrage BOT",
    url: '/arbitrage-bot',
    children: [
      {
        name: 'Bot Pairs',
        url: '/arbitrage-bot/bot-pairs'
      },
      {
        name: 'Bot History',
        url: '/arbitrage-bot/arbitrage-bot-history'
      },
      {
        name: 'Bot Orders',
        url: '/arbitrage-bot/arbitrage-bot-orders'
      },
      {
        name: 'Bot Position History ',
        url: '/arbitrage-bot/arbitrage-bot-position'
      },
      {
        name: 'Balance Log',
        url: '/arbitrage-bot/balance-history'
      },
      {
        name: 'Cumulative Balance',
        url: '/arbitrage-bot/cumulative-history'
      },
      {
        name: 'Profit History',
        url: '/arbitrage-bot/profit-history'
      },
    ]
  },
  // {
  //   name: "Arbitrage",
  //   url: '/arbitrage',
  //   children: [

  //     {
  //       name: 'exchange History',
  //       url: '/exchangehistory'
  //     },

  //     {
  //       name: 'Exchange Investment',
  //       url: '/exchangeinvestment'
  //     },
  //     {
  //       name: 'Total Investment',
  //       url: '/totalinvestment'
  //     },


  //   ]
  // },

  // {
  //   name: 'Trading Bot',
  //   url: '/tradingbot',
  //   // iconComponent: { name: 'cil-list' }
  // },

  // {
  //   title: true,
  //   name: 'Theme'
  // },
  {
    name: 'Passbook List',
    url: '/passbook',
    // iconComponent: { name: 'cil-list' }
  },
  {
    name: 'Fake List',
    url: '/fake-list',
    children: [
      {
        name: 'Fake User List Coin Dcx ',
        url: '/fake-users',
      },
      {
        name: 'Fake Passbook List',
        url: '/fake-passbook',
        // iconComponent: { name: 'cil-list' }
      },
      {
        name: 'Zero Bal Passbook Issues',
        url: '/zero-bal-passbook-issues',
        // iconComponent: { name: 'cil-list' }
      },
      {
        name: 'Fake Binance order',
        url: '/fake-order',
        // iconComponent: { name: 'cil-list' }
      },
      {
        name: 'Fake CoinDcx order',
        url: '/fake-CoinDcxorder',
        // iconComponent: { name: 'cil-list' }
      },
      {
        name: 'Fake Cred order',
        url: '/fake-cred-order',
        // iconComponent: { name: 'cil-list' }
      },

      {
        name: 'Missing Trade History',
        url: '/missing-trade-history',
        // iconComponent: { name: 'cil-list' }
      },
    ]
  },
  {
    name: "Coin Details",
    url: '/currency',
    // iconComponent: { name: 'cil-user' },
    children: [
      {
        name: 'Coin List',
        url: '/currency'
      }
    ]
  },
  {
    name: "Transfer History",
    url: '/transfer',
    // iconComponent: { name: 'cil-user' },
    children: [
      {
        name: 'Deposit',
        url: '/transfer/deposit'
      },
      {
        name: 'Withdraw',
        url: '/transfer/withdraw'
      },

    ]
  },

  {
    name: 'Price Conversion',
    url: '/priceconversion'
  },


  {
    name: 'Admin Profit',
    url: '/adminprofit'
  },
  {
    name: 'Admin Wallet',
    url: '/adminwallet'
  },
  {
    name: 'Deposite commision',
    url: '/deposite-commision'
  },
  {
    name: 'Email Templates',
    url: '/emailtemplates'
  },
  {
    name: 'CMS Pages',
    url: '/cmspages',
    children: [
      {
        name: 'Offers',
        url: '/earn-offers/offers'
      },
      {
        name: 'Announcement',
        url: '/announcement'
      },
      {
        name: 'Blog Page',
        url: '/blog-page'
      },
      {
        name: 'Learn Page',
        url: '/learn-page'
      },
    ]
  },
  {
    name: "Airdrop",
    url: '/airdrop',
    // iconComponent: { name: 'cil-user' },
    children: [
      {
        name: 'Airdrop',
        url: '/airdrop/list'
      },
      {
        name: 'Airdrop History',
        url: '/airdrop/history'
      },
    ]
  },
  {
    name: "Launchpad",
    url: '/launchpad',
    // iconComponent: { name: 'cil-user' },
    children: [
      {
        name: 'Launchpad',
        url: '/launchpad/list'
      },
      {
        name: 'Token History',
        url: '/launchpad/token-history'
      },
    ]
  },
  // {
  //   name: 'Airdrop',
  //   url: '/airdrop/list'
  // },
  // {
  //   name: 'Airdrop History',
  //   url: '/airdrop/history'
  // },
  {
    name: 'Sliders',
    url: '/sliders'
  },
  {
    name: 'Contact Us',
    url: '/contact-us'
  },
  {
    name: 'Site Setting',
    url: '/site-setting'
  },

  {
    name: 'Upline Referral',
    url: '/upline-refferel'
  },
  {
    name: 'Support Category',
    url: '/support-category'
  },
  {
    name: 'Support',
    url: '/support-ticket'
  },
  {
    name: 'Sub Admin',
    url: '/subadmin'
  },
  {
    name: 'News Letter',
    url: '/newsletter'
  },

  {
    name: "Earn",
    url: '/earn',
    children: [
      {
        name: 'Earning Coins',
        url: '/earn/earn'
      },
      {
        name: 'User Holding',
        url: '/earn/UserHoldings'
      },
      {
        name: 'Earnings Request',
        url: '/earn/earnRequest'
      },
      {
        name: 'Relesed Earnings',
        url: '/earn/ReleasedEarn'
      },
      {
        name: 'Referral Earnings',
        url: '/earn/referralEarn'
      },
    ]
  },
  {
    name: 'TDS',
    url: '/tds',
    children: [
      {
        name: 'TDS Master',
        url: '/tds'
      },
      // {
      //   name: 'Withdraw',
      //   url: '/tds/withdraw'
      // },
      {
        name: 'TDS Report',
        url: '/tds/TDSReport'
      },
      {
        name: 'Trade TDS Report',
        url: '/tds/trade_tds_report'
      }
    ]
  },

  {
    name: 'Meta Mask',
    url: '/meta-wallet',
    children: [
      {
        name: 'Meta Admin Wallet',
        url: '/meta-wallet'
      },
      {
        name: 'Meta Normal Transaction',
        url: '/meta-user-wallet'
      },
      {
        name: 'Meta Token Transaction',
        url: '/meta-token-transaction'
      }
    ]
  }
  ,
  {
    name: "earn-offers",
    url: '/earn-offers',
    children: [
      {
        name: 'Offers',
        url: '/earn-offers/offers'
      },
      {
        name: 'Trade Contest',
        url: '/earn-offers/trade-contest'
      }
    ]
  },


  // {
  //   name: "Admin Controller",
  //   url: '/subadmin',
  //   // iconComponent: { name: 'cil-user' },
  //   children: [
  //     {
  //       name: 'Sub Admin',
  //       url: '/subadmin'
  //     },
  //     {
  //       name: 'Modules',
  //       url: '/modules'
  //     },
  //     {
  //       name: 'Sub Modules',
  //       url: '/submodules'
  //     },



  //   ]
  // },
  // {
  //   name: 'Typography',
  //   url: '/theme/typography',
  //   linkProps: { fragment: 'someAnchor' },
  //   iconComponent: { name: 'cil-pencil' }
  // },
  // {
  //   name: 'Components',
  //   title: true
  // },
  // {
  //   name: 'Base',
  //   url: '/base',
  //   iconComponent: { name: 'cil-puzzle' },
  //   children: [
  //     {
  //       name: 'Accordion',
  //       url: '/base/accordion'
  //     },
  //     {
  //       name: 'Breadcrumbs',
  //       url: '/base/breadcrumbs'
  //     },
  //     {
  //       name: 'Cards',
  //       url: '/base/cards'
  //     },
  //     {
  //       name: 'Carousel',
  //       url: '/base/carousel'
  //     },
  //     {
  //       name: 'Collapse',
  //       url: '/base/collapse'
  //     },
  //     {
  //       name: 'List Group',
  //       url: '/base/list-group'
  //     },
  //     {
  //       name: 'Navs & Tabs',
  //       url: '/base/navs'
  //     },
  //     {
  //       name: 'Pagination',
  //       url: '/base/pagination'
  //     },
  //     {
  //       name: 'Placeholder',
  //       url: '/base/placeholder'
  //     },
  //     {
  //       name: 'Popovers',
  //       url: '/base/popovers'
  //     },
  //     {
  //       name: 'Progress',
  //       url: '/base/progress'
  //     },
  //     {
  //       name: 'Spinners',
  //       url: '/base/spinners'
  //     },
  //     {
  //       name: 'Tables',
  //       url: '/base/tables'
  //     },
  //     {
  //       name: 'Tabs',
  //       url: '/base/tabs'
  //     },
  //     {
  //       name: 'Tooltips',
  //       url: '/base/tooltips'
  //     }
  //   ]
  // },
  // {
  //   name: 'Buttons',
  //   url: '/buttons',
  //   iconComponent: { name: 'cil-cursor' },
  //   children: [
  //     {
  //       name: 'Buttons',
  //       url: '/buttons/buttons'
  //     },
  //     {
  //       name: 'Button groups',
  //       url: '/buttons/button-groups'
  //     },
  //     {
  //       name: 'Dropdowns',
  //       url: '/buttons/dropdowns'
  //     },
  //   ]
  // },
  // {
  //   name: 'Forms',
  //   url: '/forms',
  //   iconComponent: { name: 'cil-notes' },
  //   children: [
  //     {
  //       name: 'Form Control',
  //       url: '/forms/form-control'
  //     },
  //     {
  //       name: 'Select',
  //       url: '/forms/select'
  //     },
  //     {
  //       name: 'Checks & Radios',
  //       url: '/forms/checks-radios'
  //     },
  //     {
  //       name: 'Range',
  //       url: '/forms/range'
  //     },
  //     {
  //       name: 'Input Group',
  //       url: '/forms/input-group'
  //     },
  //     {
  //       name: 'Floating Labels',
  //       url: '/forms/floating-labels'
  //     },
  //     {
  //       name: 'Layout',
  //       url: '/forms/layout'
  //     },
  //     {
  //       name: 'Validation',
  //       url: '/forms/validation'
  //     }
  //   ]
  // },
  // {
  //   name: 'Charts',
  //   url: '/charts',
  //   iconComponent: { name: 'cil-chart-pie' }
  // },
  // {
  //   name: 'Icons',
  //   iconComponent: { name: 'cil-star' },
  //   url: '/icons',
  //   children: [
  //     {
  //       name: 'CoreUI Free',
  //       url: '/icons/coreui-icons',
  //       badge: {
  //         color: 'success',
  //         text: 'FREE'
  //       }
  //     },
  //     {
  //       name: 'CoreUI Flags',
  //       url: '/icons/flags'
  //     },
  //     {
  //       name: 'CoreUI Brands',
  //       url: '/icons/brands'
  //     }
  //   ]
  // },
  // {
  //   name: 'Notifications',
  //   url: '/notifications',
  //   iconComponent: { name: 'cil-bell' },
  //   children: [
  //     {
  //       name: 'Alerts',
  //       url: '/notifications/alerts'
  //     },
  //     {
  //       name: 'Badges',
  //       url: '/notifications/badges'
  //     },
  //     {
  //       name: 'Modal',
  //       url: '/notifications/modal'
  //     },
  //     {
  //       name: 'Toast',
  //       url: '/notifications/toasts'
  //     }
  //   ]
  // },
  // {
  //   name: 'Widgets',
  //   url: '/widgets',
  //   iconComponent: { name: 'cil-calculator' },
  //   badge: {
  //     color: 'info',
  //     text: 'NEW'
  //   }
  // },
  // {
  //   title: true,
  //   name: 'Extras'
  // },
  // {
  //   name: 'Pages',
  //   url: '/login',
  //   iconComponent: { name: 'cil-star' },
  //   children: [
  //     {
  //       name: 'Login',
  //       url: '/login'
  //     },
  //     {
  //       name: 'Register',
  //       url: '/register'
  //     },
  //     {
  //       name: 'Error 404',
  //       url: '/404'
  //     },
  //     {
  //       name: 'Error 500',
  //       url: '/500'
  //     }
  //   ]
  // },
];
